module.exports = __webpack_public_path__ + "static/media/bethel.34f25716.jpg";